import React, { Component } from 'react';

class ElementLibraryFilter extends Component {
  constructor(props) {
    super(props);
    this.renderFilter = this.renderFilter.bind(this);
    this.renderSort = this.renderSort.bind(this);
  }

  renderFilter() {
    const { filter } = this.props.i18n;

    return (
      <select
        className="ElementLibrary-dropdown"
        onChange={this.props.filterData}
      >
        <option value="user">{filter.user}</option>
        <option value="company">{filter.company}</option>
      </select>
    );
  }

  renderSort() {
    const { filter } = this.props.i18n;

    return (
      <select
        className="ElementLibrary-dropdown"
        onChange={this.props.sortData}
      >
        <option value="created_at">{filter.recent}</option>
        <option value="title">{filter.alphabetical}</option>
      </select>
    );
  }

  render() {
    return (
      <div className="ElementLibrary-filter d-f jc-sb f-sh-0">
        {this.renderFilter()}
        {this.renderSort()}
      </div>
    );
  }
}

export default ElementLibraryFilter;
